import { memo } from 'react'

import { ContactWorkflowStatus } from 'clickNgo/entities/contact'
import { ContactAdditionalInfo } from 'clickNgo/entities/contact/ui/contactAdditionalInfo'
import { ValidationType } from 'cng-common/features/form/configs'

import { ContactEditorFormKeys } from '../../../configs'
import { useReadOnlyMenuItem } from '../../../hooks/useReadOnlyMenuItem'
import {
  TContactEditorContextProps,
  TContactEditorData,
  TContactEditorHandles,
} from '../../../models'
import { ContactEditableContainer } from '../../contactEditableContainer'

import { useContactAdditionalInfoUpdate } from './hooks'

type TProps = Pick<TContactEditorData, 'contact' | 'contactFlags'> &
  Pick<TContactEditorHandles, 'onContactUpdate'> &
  TContactEditorContextProps

export const WrappedContactAdditionalInfo = memo<TProps>(
  ({ contact, contactFlags, source, requestPartnerId, isOnboarding, onContactUpdate }) => {
    const { isCurrentMenuItemReadOnly } = useReadOnlyMenuItem()
    const { onApplyHandler, onCancelHandle, hasModifiedValues } = useContactAdditionalInfoUpdate({
      contact,
      source,
      requestPartnerId,
      onContactUpdate,
    })

    const onSaveAsDraft = isOnboarding
      ? () => onApplyHandler({ workflowStatus: ContactWorkflowStatus.Draft })
      : undefined

    return (
      <ContactEditableContainer
        contact={contact}
        contactFlags={contactFlags}
        hasModifiedValues={hasModifiedValues}
        onApply={onApplyHandler}
        onSaveAsDraft={onSaveAsDraft}
        onCancel={onCancelHandle}
        onUpdate={onContactUpdate}
      >
        <ContactAdditionalInfo
          contact={contact}
          formKeys={ContactEditorFormKeys}
          isReadOnly={isCurrentMenuItemReadOnly}
          validationType={ValidationType.ONCHANGE}
        />
      </ContactEditableContainer>
    )
  }
)

WrappedContactAdditionalInfo.displayName = 'WrappedContactAdditionalInfo'
